import * as Yup from 'yup';

export default Yup.object().shape({
  country: Yup.array().of(Yup.string()),
  name: Yup.string().required('Name is required'),
  logo: Yup.string().required('Logo is required')
});
